export default "__VITE_ASSET__DjwanKzr__"